module.exports = __webpack_public_path__ + "img/phone.616473e5.png";